<template>
  <v-app id="backGND">
      <navBar />
    <div id="triangle_down">
      <div id="triangle">
        <h1
          class="rotate"
          style="
            margin: auto;
            text-align: left;
            font-family: 'Poiret One', sans-serif;
            color: white;
            padding-left: 1rem;
            font-size: 3rem;
          "
        >
          Conócenos!
        </h1>
      </div>
    </div>
     <cardinfo />  
    <paulina />
     
    <woman2 />
    <woman3 />
    <foot />
  </v-app>
</template>
<script>
import foot from "@/components/footer";
import navBar from "@/components/navbar";
import paulina from "@/components/about_us_components/paulina"
import woman2 from "@/components/about_us_components/woman2"
import woman3 from "@/components/about_us_components/woman3"
import cardinfo from "@/components/about_us_components/cardinfo"

export default {
    components: { navBar, foot, paulina, woman2, woman3, cardinfo }
};
</script>
<style scoped>
#backGND {
  background-image: url("../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}
#triangle_down {
  height: 10rem;

  background: linear-gradient(
    to top right,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    rgba(200, 200, 200, 1) 50%,
    rgba(200, 200, 200, 1) 100%
  );
}
#triangle {
  height: 10rem;
  background: linear-gradient(
    to top left,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    #000000 50%,
    #000000 100%
  );
}
.rotate {
  transform: rotate(-5deg);
}
</style>



// WEBPACK FOOTER //
// src/components/about_us.vue